import React from 'react';
import Charts from '../../components/Chart/chart'


class Chart extends React.Component {
	constructor(props) {
		super(props);
	}
	
	render() {
		const { data, title, xtitle, ytitle, legendData, chartType } = this.props.chartData;
		const minValue = parseInt(this.props.chartData.minValue);
		const maxValue = parseInt(this.props.chartData.maxValue);
		const { windowHeight, windowWidth, barWidth } = this.props;
		return (
			<Charts
				data={data}
				title={title}
				xtitle={xtitle}
				ytitle={ytitle}
				minValue={minValue}
				maxValue={maxValue}
				legendData={legendData}
				height={windowHeight}
				width={windowWidth}
				chartType={chartType}
				barWidth={barWidth}
			/>

		)
	}
}

export default Chart;